import { CalendarDays, GraduationCap, House, MessageCircle, Trophy } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';
import { cn } from 'shared/utils/cn';

const NAV_ITEMS = [
  { to: ROUTES.HOME, icon: House, label: 'Início' },
  { to: ROUTES.MY_AGENDA, icon: CalendarDays, label: 'Agenda' },
  { to: ROUTES.CLASSES, icon: GraduationCap, label: 'Aulas' },
  { to: ROUTES.TOURNAMENTS, icon: Trophy, label: 'Torneios' },
  { to: ROUTES.MURAL, icon: MessageCircle, label: 'Mural' },
];

export function PlayerBottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-10 border-t border-border bg-surface">
      <div className="mx-auto flex max-w-2xl items-center justify-around py-2">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === ROUTES.HOME}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 px-2 py-1 text-xs',
                isActive ? 'text-primary' : 'text-ink-secondary'
              )
            }
          >
            <item.icon className="h-5 w-5" aria-hidden="true" />
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
